module.exports = __webpack_public_path__ + "img/17.112d3afb.svg";